import React from "react";

// =====================================================================
// Club Radar V2 — country flag chip (Brief Rule 3: FLAG EXCEPTION).
//
// Wherever a country renders, the platform's IMAGE-flag idiom is the
// mandated renderer — NEVER emoji, NEVER the handoff's CSS-gradient
// sample chips (their `F` map is illustrative only). Same recipe as the
// promoted image-flag components (agency/v2/FlagChip.js, and the URL
// branch of club-radar ClubRadarBits `Flag`): <img src>, hide on error,
// render nothing when no image exists — never a faked flag.
//
// The artboard defines SIZING/STYLING only (Symbol library "FLAG"):
//   row     → 17×12, r2.5  (table rows 1a/1b, mobile rows 1e/1k, 1m)
//   drawer  → 18×13, r2.5  (entry drawer identity 1j)
//   profile → 19×14, r3    (player-profile header 1l)
// All with ring `inset 0 0 0 1px rgba(17,24,39,.12)`, flex none.
// =====================================================================

const SIZES = {
  row: { width: 17, height: 12, borderRadius: 2.5 },
  drawer: { width: 18, height: 13, borderRadius: 2.5 },
  profile: { width: 19, height: 14, borderRadius: 3 },
};

const FlagChip = ({ src, alt = "", size = "row", style, ...rest }) => {
  if (!src) return null;
  const s = SIZES[size] || SIZES.row;
  return (
    <img
      src={src}
      alt={alt}
      referrerPolicy="no-referrer"
      style={{
        ...s,
        objectFit: "cover",
        boxShadow: "inset 0 0 0 1px rgba(17,24,39,.12)",
        flex: "none",
        display: "block",
        ...style,
      }}
      onError={(e) => {
        e.target.style.display = "none";
      }}
      {...rest}
    />
  );
};

export default FlagChip;
